import {useNavigate} from "react-router-dom";
import React from "react";
import {Button} from "@mui/material";
import {Home} from "@mui/icons-material";

export const NotFoundPage = () => {
  const navigate = useNavigate()
  return (
    <>
      <h1>Page not found</h1>
      <Button variant="contained" startIcon={<Home/>} onClick={() => navigate('/')}>Back home</Button>
    </>
  )
}